import { LoaderFunction } from 'react-router-dom';

import { LiveTrainingCardProps } from 'src/components/LiveTrainingCard';

import { mockCalendarEvents } from './__fixtures__/calendarEvents';

export interface CalendarLoaderProps {
  calendarEvents: LiveTrainingCardProps[];
}

export const loader: LoaderFunction = async (): Promise<CalendarLoaderProps> => ({
  calendarEvents: mockCalendarEvents,
});
